import 'element-remove' // used by deck.gl
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()
